import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PdfActionButton from "../PdfActionButton";

export default function KitPdfOptionsModal({ onClose, kitId }) {
  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box position="relative">
          <Typography fontSize={24} fontWeight={500} color="text.secondary" align="center">
            Kit PDF Options
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ position: "absolute", right: 0, top: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box py={3}>
          <Box>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
              Choose whether to include component images in the PDF.
            </Typography>
            <Box display="flex" gap={2}>
              <PdfActionButton
                resourceType="kit_pdfs"
                resourceId={kitId}
                extraQueryParams={{ noimage: true }}
                onOpenComplete={onClose}
                variant="outlined"
                color="primary"
                sx={{ flex: 1 }}
              >
                Without Image
              </PdfActionButton>
              <PdfActionButton
                resourceType="kit_pdfs"
                resourceId={kitId}
                onOpenComplete={onClose}
                variant="contained"
                color="primary"
                sx={{ 
                  flex: 1,
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                    color: 'white'
                  }
                }}
              >
                With Image
              </PdfActionButton>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
